import { Link, Typography } from "@aviary";
import type { TypographyType } from "@aviary/components/Typography";
import type { LinkProps } from "@shared/react-router-dom/react-router-dom";

import * as styles from "./BrandName.styles";

type BaseLinkProps = Partial<Pick<LinkProps, "to" | "replace">>;

interface Props extends BaseLinkProps {
  name: string;
  isNoClip?: boolean;
  type?: TypographyType;
  isSecondaryWeight?: boolean;
}

const BrandName = ({ name, to, isNoClip, type, isSecondaryWeight, ...rest }: Props) => {
  const brandStyles = [styles.brandName, isNoClip && styles.noClip];

  return (
    <Typography
      isMarginless
      isSecondaryWeight={isSecondaryWeight}
      title={name}
      type={type}
      css={brandStyles}
    >
      {to ? (
        <Link to={to} css={brandStyles} title={name} {...rest}>
          {name}
        </Link>
      ) : (
        name
      )}
    </Typography>
  );
};

export { BrandName };
